const pause = delayMs => new Promise(resolve => setTimeout(resolve, delayMs));

export interface RetryOptions {
  delayBase?: number;
  delayCoefficientMs?: number;
  maxAttempts?: number;
  shouldRetryFn?: (reason: any) => boolean;
}

const isAxios404 = err => err && err.response && err.response.status === 404;

export const retryOnNotFoundError = <T>(getFn: () => Promise<T>, options?: RetryOptions): Promise<T> => {
  const delayBase = (options && options.delayBase) || 2;
  const delayCoeffSeconds = (options && options.delayBase) || 1;
  const maxAttempts = (options && options.maxAttempts) || 5;
  const testFn = (options && options.shouldRetryFn) || isAxios404;

  const apiCallWithRetry = (attempts: number, e?) => {
    if (attempts >= maxAttempts) {
      return Promise.reject({ exceededRetryLimit: true, error: e });
    }
    return getFn()
      .catch(err => {
        if (testFn(err)) {
          const secondsToMs = 1000;
          const delayInMs = secondsToMs * Math.pow(delayBase, attempts) * delayCoeffSeconds;
          return pause(delayInMs)
            .then(_ => {
              return apiCallWithRetry(attempts + 1, e);
            });
        } else {
          return Promise.reject(err);
        }
      });
  };

  return apiCallWithRetry(0);
};